import { Architecture, DesignServices, Palette } from '@mui/icons-material'
import React from 'react'

export const founderPhilosophy = [
  {
    icon:        <DesignServices sx={{ fontSize: 48 }}/>,
    title:       'Narrative-Driven Design',
    description: 'We translate personal stories into spatial experiences. Each project begins with deep discovery, ensuring every detail reflects the client\'s unique journey and aspirations.',
    color:       '#B89968',
    accent:      'Story First'
  }, {
    icon:        <Architecture sx={{ fontSize: 48 }}/>,
    title:       'Precision Craftsmanship',
    description: 'Meticulous attention to detail meets artisanal excellence. We collaborate with master craftsmen to create custom elements that elevate spaces beyond the conventional.',
    color:       '#8B7355',
    accent:      'Artisan Made'
  }, {
    icon:        <Palette sx={{ fontSize: 48 }}/>,
    title:       'Experiential Design',
    description: 'Spaces should engage, inspire, and transform. We design for how environments feel in motion, creating intuitive flow and emotional resonance.',
    color:       '#7A9E9F',
    accent:      'Multi-Sensory'
  }]
